import React, { Fragment, useState, useEffect } from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import {
  DeviceType,
  FormCreationData,
  SAVE_FORM_JSON,
  UPDATE_PARENT_FIELDS,
} from "../../../../../stateManager/store/formCreation_v2/types";
import { containers } from "../constants";
import { getComponents, handleContainers, onDrop } from "../helpers";
import { ItemTypes } from "../types/ItemTypes";
import { ElementWrapper } from "./ElementWrapper";
import MicroComponents from "./MicroComponents";
import { ReactComponent as TabBarPlaceholder } from '../../../../../assets/svg/tabbarplace.svg'
import {
  getGridStyles as getContainerStyles, getMargin,
  getPadding
} from "../helpers/generateStyles";
import { Tab } from "@headlessui/react";
import "../style/formbuilder.scss"
import { useTopElement } from "../hooks/useTopElement";
import { setMultipleSelectionv2 } from "../../../../../stateManager/store/contextMenuv2/action";
import { addWrapperComputedStyles, setSelectedFormItemId, updatedSelectedeElements, updateElement } from "../../../../../stateManager/store/formCreation_v2/actions";
import { clearSelectedItems } from "../../../../../stateManager/store/contextMenu/action";
import { relative } from "path";
import { HandleContainersV3 } from "../helpers/HandleLayoutComponentsv3";
import { MouseHoverOnTree } from "../../../../../helpers/RxServices";
import { wizardContentInitialState } from "../helpers/wizardHelpers";
import { store } from "../../../../../stateManager";
import classNames from "classnames";

interface ITabBar {
  deviceType: DeviceType;
  element: FormCreationData;
  isCheckedIn?: Boolean;
}
export const TabBar: React.FC<ITabBar> = ({
  isCheckedIn,
  element,
  deviceType,
}) => {
  const { id, fields, type, properties, isChildAsset, isAsset, renderer = false } = element;
  const { config } = element?.properties
  const { selectedElementId, isCoreV3, newId } = useSelector((state: any) => state.formJson);
  const { components } = getComponents();
  const [isTop, setIsTop] = useTopElement()
  const dispatch = useDispatch();
  const [hoveredElId, setHoveredElId] = useState<string>()
  const [isBlurred, setIsBlurred] = useState(false);

  const styles = element?.properties?.styles?.[deviceType] || {};
  const containerStyles = getContainerStyles(styles);
  const [currentTabId, setCurrentTabId] = useState<any>("")
  const tabFields = components[currentTabId]?.fields;
  const newStyles: { [key: string]: any } = {
    ...element?.properties?.styles?.common,
    ...element?.properties?.styles?.[deviceType],
  };
  const { backgroundColor, height, heightMode, width, widthMode, fontFamily = 'inherit' , border, borderColor, borderRadius, visible} = newStyles;
  // const marginStyle = getMargin(newStyles);
  const paddingStyle = getPadding(styles);
  const editable = !renderer ? true : false;
  const visibilityGen = `${visible === true ? "block" : visible ? "block" : "hidden"}`;

  const handleSelect = async (e: React.MouseEvent<HTMLDivElement>, id: any,) => {
    e.stopPropagation();
    if (e.shiftKey && !isChildAsset) {
      dispatch(setMultipleSelectionv2(true));
      dispatch(updatedSelectedeElements(id));
    } else {

      const existingWrapper = document.getElementById("wrapper");
      existingWrapper && await existingWrapper.remove();
      await dispatch(setMultipleSelectionv2(false));
      await dispatch(
        setSelectedFormItemId({
          id,
          isAssetInstanceSelected: isAsset || isChildAsset,
        })
      );
      await dispatch(clearSelectedItems())
    }
  };

  const handleRightClick = async (e: React.MouseEvent<HTMLDivElement>, id: any) => {
    e.stopPropagation();
    const existingWrapper = document.getElementById("wrapper");
    existingWrapper && await existingWrapper.remove();
    await dispatch(
      setSelectedFormItemId({
        id,
        isAssetInstanceSelected: isAsset || isChildAsset,
      })
    );
    await dispatch(clearSelectedItems());
  };

  useEffect(() => {
    if (currentTabId && !fields.includes(currentTabId)) {
      setCurrentTabId(newId);
    }
  }, [tabFields])

  useEffect(() => {
    if (fields && fields.length && (currentTabId === "" || !fields.includes(currentTabId))) {
      setCurrentTabId(fields[0])
    }
  }, [fields, currentTabId])
  useEffect(() => {
    setIsTop(id)
  }, [id, setIsTop])
  const [{ isOverCurrent, canDrop }, drop] = useDrop({
    accept: [ItemTypes.ELEMENT, ItemTypes.COMPONENT, ItemTypes.TEMPLATE],
    canDrop: (item: any) => {
      // 1. the source grid itself gets dropped
      if (id === item.json.id) {
        return false;
      }

      if (item.json.type === "Spacer") {
        return false;
      }

      // 2. the dragged item is already present in the grid
      if (item.type === ItemTypes.ELEMENT && item.json.parentId === id) {
        return false;
      }

      // 3. preventing asset modification and maintaining asset structure
      if(isAsset || isChildAsset){
        return false;
      }

      return true;
    },
    collect: (monitor) => {
      return {
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
      };
    },
    drop: async(item: any) => {
      if (isOverCurrent) {
        let id: any;
          if (item?.json?.type !== 'FormWizard') {
            id = onDrop({ id: currentTabId }, item, deviceType, isCoreV3);
          }
        if (item?.json?.type === "TabBar") {
          let data: any = {
            type: "Component",
            json: {
              type: 'Tab',
              label: 'Tab 1',
              value: "tab 1"
            }
          }
          onDrop({ id }, data, deviceType, isCoreV3)
        } else if (item?.json?.type === "FormWizard") {
          onDrop({ id: currentTabId }, {type: ItemTypes.FORMWIZARD, json: {}}, deviceType, isCoreV3);
        }
      }
    },
  });
  const getHeight = (): string => {
    let returnVal = "";
    if (heightMode === 'auto') {
      returnVal = "auto"
    } else if (heightMode === 'min-content') {
      returnVal = "min-content"
    } else if (heightMode === 'max-content') {
      returnVal = "max-content"
    } else if (heightMode === '%' || heightMode === 'px') {
      returnVal = `${height}${heightMode}`
    } else if (!fields.length) {
      returnVal = "100%"
    } else {
      returnVal = "100%"
    }
    return returnVal
  }
  const getWidth = (): string => {
    if (widthMode === 'auto') {
      return "fit-content"
    } else if (widthMode === 'min-content') {
      return "min-content"
    } else if (widthMode === 'max-content') {
      return "max-content"
    } else if (width) {
      return `${width}${newStyles.widthMode}`;
    }
    return "100%"
  }

  const elementStyle = properties?.styles || {};
  const marginStyle = getMargin(elementStyle[deviceType])

  const tabbarStylesV3: React.CSSProperties = {
    width: getWidth(),
    height: getHeight(),
    ...marginStyle,
    ...paddingStyle,
    ...(border ? { borderWidth: border + "px" } : { borderWidth: "1px" }),
    ...(borderRadius ? { borderRadius: borderRadius + "px" } : { borderRadius: "6px" }),
    ...(borderColor ? { borderColor: borderColor } : { borderColor: "#95ABD34D" }),
    flexShrink: 0,
    fontFamily: fontFamily || 'Inherit',
    backgroundColor: hoveredElId === id ? "#EFF0F4" : ""
  }

  const calcHeight = () => {
    let returnVal = ""
    if (heightMode === 'auto') {
      returnVal = "fit-content"
    } else if (heightMode === 'min-content') {
      returnVal = "min-content"
    } else if (heightMode === 'max-content') {
      returnVal = "max-content"
    } else {
      returnVal = `calc(${styles.height}${styles.heightMode} - 45px)`
    }
    return returnVal
  }
  const getTabcontentStyles = (): React.CSSProperties => {
    return {
      overflow: "auto",
      height: "100%",
      // maxHeight: `${calcHeight()}`,
      display: "flex",
      flexDirection: "column",
      minHeight: "45px",
      backgroundColor: backgroundColor ? backgroundColor : "#FEFEFE",
      padding: config?.padding?.overall !== "0"
        && config?.padding?.overall !== "" ? `${config?.padding?.overall}px` :
        `${config.padding.top}px ${config.padding.right}px ${config.padding.bottom}px ${config.padding.left}px`,
    }
  }

  const handleKeyPress = (event: React.KeyboardEvent) => {
    const selection: any = window.getSelection();
    const currentRange = selection.getRangeAt(0);
    let newPosition = 0;
    if (event.key === 'ArrowRight') {
      const endContainer = currentRange.endContainer;
      newPosition = currentRange.endOffset + 1;
      if (newPosition > endContainer.length) {
        currentRange.setStart(endContainer, endContainer.length);
        currentRange.setEnd(endContainer, endContainer.length);
      } else {
        currentRange.setStart(endContainer, newPosition);
        currentRange.setEnd(endContainer, newPosition);
      }

      selection.removeAllRanges();
      selection.addRange(currentRange);
      event.preventDefault();

    } else if (event.key === 'ArrowLeft') {
      const startContainer = currentRange.startContainer;
      newPosition = currentRange.endOffset - 1;
      if (newPosition < 0) {
        currentRange.setStart(startContainer, 0);
        currentRange.setEnd(startContainer, 0);
      } else {
        currentRange.setStart(startContainer, newPosition);
        currentRange.setEnd(startContainer, newPosition);
      }

      selection.removeAllRanges();
      selection.addRange(currentRange);
      event.preventDefault();
    } else if (event.keyCode === 32) {
      event.preventDefault();
      const offset = currentRange.startOffset;
      const startContainer = currentRange.startContainer;
      const originalText = startContainer.nodeValue || '';
  
      const updatedText = originalText.slice(0, offset) + ' ' + originalText.slice(offset);
      startContainer.nodeValue = updatedText;
  
      currentRange.setStart(startContainer, offset + 1);
      currentRange.setEnd(startContainer, offset + 1);
      selection.removeAllRanges();
      selection.addRange(currentRange);
    } else if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  const isActive = isOverCurrent && canDrop;
  const animationClass = isActive
    ? "drop-active"
    : canDrop
      ? "drop-passive"
      : "";

  const combinedClassName = properties?.config?.classNameTags?.join(" ") || [];
  function kebabToCamel(kebab: any) {
    return kebab.replace(/-([a-z])/g, (match: any, letter: any) => letter.toUpperCase());
  }

  useEffect(() => {
    if (selectedElementId === id && type === "TabBar") {
      const childElement = document.getElementById(`${type}-${id}`)
      if (childElement) {
        const computedStyles = window.getComputedStyle(childElement);
        const camelCaseStyles: any = {};

        for (let i = 0; i < computedStyles.length; i++) {
          const prop = computedStyles[i];
          const value = computedStyles.getPropertyValue(prop);
          const camelProp = kebabToCamel(prop);
          camelCaseStyles[camelProp] = value;
        }
        const selectedStyles = {
          width: camelCaseStyles.width,
          height: camelCaseStyles.height,
          marginTop: camelCaseStyles.marginTop,
          marginBottom: camelCaseStyles.marginBottom,
          marginLeft: camelCaseStyles.marginLeft,
          marginRight: camelCaseStyles.paddingRight,
          position: camelCaseStyles.position,
          lineHeight: camelCaseStyles.lineHeight,
          backgroundColor: computedStyles.getPropertyValue("background-color"),
          borderColor: computedStyles.getPropertyValue("border-color")
        };
        dispatch(addWrapperComputedStyles(selectedStyles))
      }
    }
  }, [selectedElementId])
  
  const subscription = MouseHoverOnTree.getMessage().subscribe(function (e) {
    setHoveredElId(e);
  });

  useEffect(() => {
  
    if (!subscription) {
      MouseHoverOnTree.getMessage();
    }
    return () => {
      subscription.unsubscribe();
    };
  }, [hoveredElId]);


  if (isCoreV3) {
    return (
      <div
        className={`relative ${combinedClassName} ${visibilityGen}`}
        style={{
          ...tabbarStylesV3,
        }}
        onMouseOver={(e) => {
          e.stopPropagation();
          MouseHoverOnTree.sendMessage(id);
        }}
        onMouseLeave={() => {
          MouseHoverOnTree.sendMessage(null);
        }}
        id={`${type}-${id}`}
        onClick={(e) => handleSelect(e, id)}
        onContextMenu={(e: any) => {
          e.preventDefault();
          e.stopPropagation();
          handleSelect(e, id);
        }}
      >
        <div
          style={{ height: "100%", minHeight: "100px", background: "#f1f1f1", display: 'flex' }}
          id={id}
          className={`tab-bar `}
        >
          <div
            style={{
              flexDirection: config?.tapPosition === "top" ? "column" : "column-reverse",
              gap: styles?.gap ? `${styles?.gap}px` : "0px",
              height: "100%"
            }}
            className={`w-full flex`}
          >
            <div className="tab-bar" style={{
              overflowX: "auto",
              background: config?.background ? config.background : "white",
              borderRadius: config?.borderRadius ? `${config.borderRadius}px` : `0px`,
              border: config?.borderWidth ? `${config.borderWidth}px solid ${config?.borderColor || "transparent"}` : `0px solid transparent`
            }}>
              <Tab.Group >
                <Tab.List className="flex "
                  style={{ gap: element?.properties?.config?.tabGap ? `${element.properties.config.tabGap}px` : "0px" }}>
                  {
                    fields && fields.map((fieldId: any, index: any) => {
                      const element = components[fieldId];
                      return (
                        <Tab as={Fragment}>
                          {() => (
                            <>
                            <button
                              onBlur={(event) => {
                                const textContent = event.currentTarget.textContent;
                                dispatch(updateElement({
                                  id: element?.id,
                                  path: "label",
                                  value: textContent || ""
                                }))
                                setIsBlurred(false);
                              }}
                              onFocus={()=>
                                setIsBlurred(true)
                              }
                              onKeyDown={handleKeyPress}
                              onClick={((e: any) => {
                                handleSelect(e, fieldId)
                                setCurrentTabId(fieldId)
                              })}
                              onContextMenu={(e: any) => {
                                handleSelect(e, fieldId)
                                setCurrentTabId(fieldId)
                              }}
                              style={currentTabId === fieldId ?
                                {
                                  border: config?.selectedBorderWidth ? `${config.selectedBorderWidth}px solid ${config?.selectedBorderColor || "transparent"}` : `0px solid transparent`,
                                  background: config?.selectedTabBg,
                                  color: config?.selectedFontColor,
                                  borderRadius: `${config?.selectedBorderRadius}px`,
                                  minWidth: `${config?.tabMinWidth}px`,
                                  maxWidth: `${config?.tabMaxWidth}px`,
                                  borderBottom: config?.selectedBottomLineColor ? `3px solid ${config?.selectedBottomLineColor}` : "3px solid transparent",
                                  fontWeight: config?.selectedFontWeight,
                                  fontSize: `${config?.selectedFontSize}px`,
                                  padding: config?.tabBarPadding?.overall ? `${config?.tabBarPadding?.overall}px` : `${config?.tabBarPadding?.top}px ${config?.tabBarPadding?.right}px ${config?.tabBarPadding?.bottom}px ${config?.tabBarPadding?.left}px`,
                                  gap: "5px",
                                  cursor: "pointer"
                                }
                                : {
                                  border: config?.unSelectedBorderWidth ? `${config.unSelectedBorderWidth}px solid ${config?.unSelectedBorderColor || "transparent"}` : `0px solid transparent`,
                                  borderRadius: `${config?.unSelectedBorderRadius}px`,
                                  background: config?.unSelectedTabBg,
                                  color: config?.unSelectedFontColor,
                                  minWidth: `${config?.tabMinWidth}px`,
                                  maxWidth: `${config?.tabMaxWidth}px`,
                                  borderBottom: config?.unSelectedBottomLineColor ? `3px solid ${config?.unSelectedBottomLineColor}` : "3px solid transparent",
                                  fontWeight: config?.unSelectedFontWeight,
                                  fontSize: `${config?.unSelectedFontSize}px`,
                                  padding: config?.tabBarPadding?.overall ? `${config?.tabBarPadding?.overall}px` : `${config?.tabBarPadding?.top}px ${config?.tabBarPadding?.right}px ${config?.tabBarPadding?.bottom}px ${config?.tabBarPadding?.left}px`,
                                  gap: "5px",
                                  cursor: "pointer"
                                }}
                              className={
                                currentTabId === fieldId ? 'justify-center flex items-center focus:outline-none truncate' : 'justify-center flex gap-3 items-center truncate w-full focus:outline-none '
                              }
                            >
                              {
                                config.tapType === "text-with-icon" &&
                                (element?.selectedIconUrl && element?.unSelectedIconUrl) &&
                                <img style={{
                                  width: `auto`,
                                  height: "20px",
                                  objectFit: "contain"
                                }} src={currentTabId === fieldId ? element?.selectedIconUrl : element?.unSelectedIconUrl} alt=""></img>
                              }
                              <span
                                contentEditable={editable}
                                className={`${isBlurred ? "whitespace-pre-wrap outline-none" : "whitespace-pre"} overflow-ellipsis overflow-hidden w-full`}>
                                {element?.label}</span>
                            </button>
                            </>
                          )}
                        </Tab>
                      )
                    })
                  }
                </Tab.List>
              </Tab.Group>
            </div>
            <div id={`Tab-${currentTabId}`} className={`w-full ${containerStyles} ${animationClass}`} ref={(ref) => drop(ref)} style={getTabcontentStyles()}>
              {tabFields && tabFields.length > 0 ? (
                tabFields.map((fieldId: string, index: any) => {
                  const element = components[fieldId];
                  return (
                    <React.Fragment key={fieldId}>
                      {containers.includes(element.type) ? (
                        <HandleContainersV3 isCheckedIn={isCheckedIn} element={element} deviceType={deviceType} index={index} />
                      ) : (
                        <MicroComponents element={element} index={index} deviceType={deviceType} />
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <TabBarPlaceholder />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ fontFamily: elementStyle?.common?.fontFamily || 'Inherit' }}>
      {selectedElementId === id && type !== "FAB" && type !== "A8Modal" &&
        <p
          data-test-id={id}
          id={`tag_${id}`}
          style={{ ...marginStyle }}
          className={`${combinedClassName}` && type === "SnackBar" ? "fixed bg-palered text-sm text-white px-1 rounded-sm bottom-14 z-50 left-4 mt-3" : ` absolute bg-palered flex items-center text-sm text-white px-1 rounded h-6 bottom-0 z-50 left-0`}>
          {id}
        </p>
      }
      <div
        style={{ minHeight: "100px", background: "#f1f1f1" }}
        id={id}
        className={`tab-bar `}
      >
        <div
          style={{
            flexDirection: config?.tapPosition === "top" ? "column" : "column-reverse",

            minHeight: "100%",
            gap: styles?.gap ? `${styles?.gap}px` : "0px",
          }}
          className={`w-full flex`}
        >
          <div className="tab-bar" style={{
            overflowX: "auto",
            background: config?.background ? config.background : "white",
            borderRadius: config?.borderRadius ? `${config.borderRadius}px` : `0px`,
            border: config?.borderWidth ? `${config.borderWidth}px solid ${config?.borderColor || "transparent"}` : `0px solid transparent`
          }}>
            <Tab.Group >
              <Tab.List className="flex "
                style={{ gap: element?.properties?.config?.tabGap ? `${element.properties.config.tabGap}px` : "0px" }}>
                {
                  fields && fields.map((fieldId: any, index: any) => {
                    const element = components[fieldId];
                    return (
                      <Tab as={Fragment}>
                        {({ selected }) => (
                          <button
                            onClick={(() => { setCurrentTabId(fieldId) })}
                            style={selected ?
                              {
                                width: "auto",
                                border: config?.selectedBorderWidth ? `${config.selectedBorderWidth}px solid ${config?.selectedBorderColor || "transparent"}` : `0px solid transparent`,
                                background: config?.selectedTabBg,
                                color: config?.selectedFontColor,
                                borderRadius: `${config?.selectedBorderRadius}px`,
                                minWidth: `${config?.tabMinWidth}px`,
                                maxWidth: `${config?.tabMaxWidth}px`,
                                borderBottom: config?.selectedBottomLineColor ? `3px solid ${config?.selectedBottomLineColor}` : "3px solid transparent",
                                fontWeight: config?.selectedFontWeight,
                                fontSize: `${config?.selectedFontSize}px`,
                                padding: config?.tabBarPadding?.overall ? `${config?.tabBarPadding?.overall}px` : `${config?.tabBarPadding?.top}px ${config?.tabBarPadding?.right}px ${config?.tabBarPadding?.bottom}px ${config?.tabBarPadding?.left}px`,
                                gap: "5px",
                                cursor: "pointer"
                              }
                              : {
                                width: "auto",
                                border: config?.unSelectedBorderWidth ? `${config.unSelectedBorderWidth}px solid ${config?.unSelectedBorderColor || "transparent"}` : `0px solid transparent`,
                                borderRadius: `${config?.unSelectedBorderRadius}px`,
                                background: config?.unSelectedTabBg,
                                color: config?.unSelectedFontColor,
                                minWidth: `${config?.tabMinWidth}px`,
                                maxWidth: `${config?.tabMaxWidth}px`,
                                borderBottom: config?.unSelectedBottomLineColor ? `3px solid ${config?.unSelectedBottomLineColor}` : "3px solid transparent",
                                fontWeight: config?.unSelectedFontWeight,
                                fontSize: `${config?.unSelectedFontSize}px`,
                                padding: config?.tabBarPadding?.overall ? `${config?.tabBarPadding?.overall}px` : `${config?.tabBarPadding?.top}px ${config?.tabBarPadding?.right}px ${config?.tabBarPadding?.bottom}px ${config?.tabBarPadding?.left}px`,
                                gap: "5px",
                                cursor: "pointer"
                              }}
                            className={
                              selected ? 'justify-center flex items-center focus:outline-none truncate' : 'justify-center flex gap-3 items-center truncate w-full focus:outline-none '
                            }
                          >
                            {
                              config.tapType === "text-with-icon" &&
                              (element?.selectedIconUrl && element?.unSelectedIconUrl) &&
                              <img style={{
                                width: `auto`,
                                height: "20px",
                                objectFit: "contain"
                              }} src={currentTabId === fieldId ? element?.selectedIconUrl : element?.unSelectedIconUrl} alt=""></img>
                            }
                            <span className="truncate">{element.label}</span>
                          </button>
                        )}
                      </Tab>
                    )
                  })
                }
              </Tab.List>
            </Tab.Group>
          </div>
          <div id={`Tab-${currentTabId}`} className={`w-full ${containerStyles} ${animationClass}`} ref={(ref) => drop(ref)} style={{ padding: config?.padding?.overall !== "0" && config?.padding?.overall !== "" ? `${config?.padding?.overall}px` : `${config.padding.top}px ${config.padding.right}px ${config.padding.bottom}px ${config.padding.left}px`, minHeight: "100px" }}>
            {
              tabFields && tabFields.map((fieldId: string, index: any) => {
                const element = components[fieldId];
                const parentElement: any =
                  element.parentId && components[element.parentId];
                return (
                  <ElementWrapper isCheckedIn={isCheckedIn} key={fieldId} element={element} index={index} parentElement={parentElement}>
                    {containers.includes(element.type) ? (
                      handleContainers({ isCheckedIn, element, deviceType })
                    ) : (
                      <MicroComponents element={element} deviceType={deviceType} />
                    )}
                  </ElementWrapper>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
};
